import MuiTextField, { StandardTextFieldProps } from '@mui/material/TextField';

export interface TextFieldProps extends StandardTextFieldProps {
  label: string;
  error?: boolean;
  helperText?: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const TextField = ({ label, error, helperText, value, onChange, ...rest }: TextFieldProps) => {
  return (
    <MuiTextField
      fullWidth
      error={error}
      label={label}
      helperText={helperText}
      variant="outlined"
      value={value}
      onChange={onChange}
      onKeyDown={(e) => {
        e.stopPropagation();
      }}
      {...rest}
    ></MuiTextField>
  );
};
